// extracted by mini-css-extract-plugin
module.exports = {"category":"wV","categoryTitle":"wW","stickySearchBoxBar":"wX"};